<router-outlet />
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<ngx-spinner name="iframe" type="ball-scale-multiple"></ngx-spinner>

<!-- <ng4-loading-spinner [timeout]="10000"> </ng4-loading-spinner> -->
